import {
  fetchRequest,
  securedFetchRequest,
} from '@bidmii/common/lib/util/FetchRequest';
import {API_URL} from '../constants';

export const generateProfileBio = (userId: number, setAILoading?: any) => {
  const controller = new AbortController();
  setTimeout(() => {
    controller.abort();
    return setAILoading && setAILoading(false);
  }, 20000);

  return securedFetchRequest(`${API_URL}/ai/profile?userId=${userId}`, {
    signal: controller.signal,
  }).then((res) => res.text());
};

export const generateQuoteDescription = (
  rfp: number | string,
  bidmiiDirect: boolean,
) => {
  return securedFetchRequest(
    `${API_URL}/ai/proposal?${
      bidmiiDirect ? `rfpTitle=${rfp}` : `rfpId=${rfp}`
    }&html=true`,
  )
    .then((res) => res.text())
    .then((res) => {
      return res.includes('overloaded') ||
        res ===
          'The server had an error while processing your request. Sorry about that!'
        ? null
        : res;
    });
};

export const generateProjectProposalEstimateDescription = (rfpUid: string) => {
  const url = `${API_URL}/ai/rfps/${rfpUid}/proposal-estimate-description`;
  return fetchRequest(url)
    .then((res) => res.text())
    .then((res) => {
      return res.includes('overloaded') ||
        res ===
          'The server had an error while processing your request. Sorry about that!'
        ? null
        : res;
    });
};

export const generateProjectProposalEstimateDetails = (
  rfpUid: string,
  description: string,
) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(description, 'text/html');
  const url = `${API_URL}/ai/rfps/${rfpUid}/proposal-estimate-details?description=${doc.body.textContent}`;
  return fetchRequest(url).then((res) => res.json());
};

export const generateProjectDescription = (
  rfpTitle: string,
  rfpUid?: string,
) => {
  const url = rfpUid
    ? `${API_URL}/ai/rfps/${rfpUid}/rfp-description`
    : `${API_URL}/ai/rfp-description?title=${rfpTitle}`;
  return fetchRequest(url)
    .then((res) => res.text())
    .then((res) => {
      return res.includes('overloaded') ||
        res ===
          'The server had an error while processing your request. Sorry about that!'
        ? null
        : res;
    });
};

export const generateQuestions = (rfpId: number, userId: number) => {
  return securedFetchRequest(
    `${API_URL}/ai/rfp-questions?rfpId=${rfpId}&userId=${userId}`,
  ).then((res) => res.text());
};

let i = 0;
export const typewriter = (text: string, id: string, setLoading: any) => {
  if (i < text.length && document.getElementById(id)) {
    (document.getElementById(id) as $TSFixMe).innerHTML += text.charAt(i);
    i++;
    setTimeout(() => typewriter(text, id, setLoading), 15);
  } else {
    setLoading(false);
    i = 0;
  }
};
